import * as  React from 'react';
import { useCallback } from 'react';
import cancelEvent from '../../../services/mini/cancelEvent';


type PopupHeaderProps = {
    title?: string;
    onCancel: (value?: string) => void;
    children?: React.ReactChildren | React.ReactChild;
    titleIcon?: string;
    titleIconImg?: string;
    className?: string;
}

export default function PopupHeader({ title, titleIcon, titleIconImg, onCancel, className, children }: PopupHeaderProps) {

    const closeCb = useCallback((e) => {
        onCancel();
        cancelEvent(e);
    }, [onCancel]);

    const withTruncation = title?.length > 110 ? true : false;

    return <div className={`popup-form_header ${onCancel && 'with-close-icon'} ${className}`}>
        {titleIconImg && <img className="popup-form_img" src={titleIconImg} />}
        {/* {titleIcon && <i className={`popup-form_header_icon icon ${titleIcon}`} />} */}
        <span className={`popup-form_header-title ${withTruncation && 'with-dots'}`} title={withTruncation ? title : ''}> {title}</span>
        {onCancel && <i className="icon icon-alan-remove-fat" onMouseUp={closeCb} />}
        {children}
    </div>;
}
